// Analytics utility for homepage CTA tracking.
// Search for "HOMEPAGE_CTA_CLICK" in logs to find all get-started clicks.

import { hasConsent } from './cookieConsent';

// Get or create a session ID for tracking
const getSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem('analytics_session_id');
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
  } catch (e) {
    return null;
  }
};

// Track a get-started click.
// Search for "HOMEPAGE_CTA_CLICK" to find these in logs.
export const trackGetStartedClick = (source) => {
  if (!hasConsent('analytics')) return;
  const timestamp = new Date().toISOString();

  // Log format: HOMEPAGE_CTA_CLICK | source | timestamp — easy to grep in logs.
  console.log(`HOMEPAGE_CTA_CLICK | source=${source} | time=${timestamp}`);

  // Also store in sessionStorage for potential analytics pickup.
  try {
    const clicks = JSON.parse(sessionStorage.getItem('cta_clicks') || '[]');
    clicks.push({ source, timestamp });
    sessionStorage.setItem('cta_clicks', JSON.stringify(clicks));
  } catch (e) {
    // sessionStorage not available
  }

  // Send to BFF for persistent tracking (fire-and-forget, don't block navigation).
  fetch('/api/analytics/track', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      eventType: 'homepage_cta_click',
      source,
      sessionId: getSessionId()
    })
  }).catch(() => {
    // Silently fail - tracking shouldn't block user experience
  });
};
